import Vue from 'vue'
class UserService {
    get_users(page, data) {
        return axios.post('users?page=' + page, data)
    }
    switch_user(id, data) {
        return axios.post('users/switch-user-status/' + id, data, {
            baseURL: Vue.prototype.$baseMenaURL + 'api'
        })
    }
    add_regularity_order(id, data) {
        return axios.post('users/update-required-review-violations/' + id, data)
    }

    assign_co_menegment(id, data) {
        return axios.post('users/assign-co-management/' + id, data)
    }

    edit_role_user(id, data) {
        return axios.post('users/update-user-role/' + id, data)
    }

    add_alliances(data) {
        return axios.post('general/alliance/store_with_members', data)
    }
    edit_alliance(data) {
        return axios.post('general/alliance/update', data)
    }
    change_leader(data) {
        return axios.post('general/alliance/change_Leader', data)
    }
    remove_member(data) {
        return axios.post('general/alliance_members/remove_member', data)
    }
    add_member(data) {
        return axios.post('general/alliance_members/store', data)
    }

}
export default new UserService();